import React, { useState } from 'react';
import { safePreventDefault } from 'react-slick/lib/utils/innerSliderUtils';
import withReactiveStyleBuyButton from '../Containers/WithReactiveStyleBuyButton';
import { post } from '../Services/http';
import { translate } from '../Services/translation';

const LoadMoreButton = (props) => {
  const {
    skip,
    take,
    identifier,
    type,
    onLoaded,
    totalProducts,
    pageSize,
    onClick: loadProducts,
    filters,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const onClick = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    await loadProducts({ identifier, skip, take, type, onLoaded,filters });
    setIsLoading(false);
  };

  const getNextPageHhref = () => {
    let sum = 0;
    if (skip + take > totalProducts) {
      sum = totalProducts;
    } else {
      sum = skip + take;
    }
    return `?products=${sum}`;
  };

  return (
    <a
      href={getNextPageHhref()}
      className="btn btn--black"
      disabled={isLoading}
      onClick={onClick}
    >
      {!isLoading && translate('category.loadmore.button')}
      {isLoading && translate('category.loadmore.buttonfetching')}
    </a>
  );
};

const loadMore = async ({ identifier, skip, take, type, onLoaded, filters}) => {
  try {
    const url = new URL(window.location);
    const res = await post(`/api/loadmore/${type}${url.search}`, {
      identifier,
      skip,
      take,
      filters,
    });

    onLoaded(await res.json());
  } catch {}
};

export default withReactiveStyleBuyButton(
  LoadMoreButton,
  loadMore,
  'btn-state'
);
